// Small display formatters shared by the TSP pages.

// "2025-11-15" -> "Nov 15, 2025". Parsed as a local calendar date so the
// day never shifts with the viewer's timezone.
export function formatDate(iso) {
  if (!iso) return "";
  const [year, month, day] = iso.split("-").map(Number);
  return new Date(year, month - 1, day).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

// "2025-11-15" + "2025-11-18" -> "Nov 15–18, 2025" (same month) or the full
// range when it crosses a month/year.
export function formatDateRange(startIso, endIso) {
  if (!startIso) return "";
  if (!endIso || endIso === startIso) return formatDate(startIso);
  const [sy, sm, sd] = startIso.split("-").map(Number);
  const [ey, em, ed] = endIso.split("-").map(Number);
  const monthShort = (y, m, d) => new Date(y, m - 1, d).toLocaleDateString("en-US", { month: "short" });
  if (sy === ey && sm === em) return `${monthShort(sy, sm, sd)} ${sd}–${ed}, ${sy}`;
  return `${formatDate(startIso)} – ${formatDate(endIso)}`;
}

// 48920 -> "48,920" (Indian digit grouping, matching the rest of the TSP UI).
export function formatNumber(value) {
  return Number(value).toLocaleString("en-IN");
}

// An ISO timestamp -> "12 min ago" / "3 hrs ago" / "5 days ago" (the
// Notifications card). Falls back to the plain date once it is old enough
// that a relative phrase stops being useful.
export function formatRelativeTime(iso) {
  if (!iso) return "";
  const diffMs = Date.now() - new Date(iso).getTime();
  const minutes = Math.round(diffMs / 60000);
  if (minutes < 1) return "just now";
  if (minutes < 60) return `${minutes} min ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours} hr${hours === 1 ? "" : "s"} ago`;
  const days = Math.round(hours / 24);
  if (days < 7) return `${days} day${days === 1 ? "" : "s"} ago`;
  return formatDate(iso.slice(0, 10));
}

// "Prem Das" -> "PD", "Radha" -> "R" (avatar initials).
export function initialsOf(name) {
  const parts = (name || "").trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  return (parts[0][0] + (parts.length > 1 ? parts[parts.length - 1][0] : "")).toUpperCase();
}
